import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IPurchaseRequest } from "src/models/Products/PurchaseRequest.models";

interface PurchaseRequestState {
    purchaseRequests: IPurchaseRequest[];
    purchaseRequestToEdit: IPurchaseRequest | null;
}

const initialState: PurchaseRequestState = {
    purchaseRequests: [],
    purchaseRequestToEdit: null,
};

const PurchaseRequestSlice = createSlice({
    name: "PurchaseRequest",
    initialState,
    reducers: {
    setPurchaseRequestList: (
        state,
        action: PayloadAction<IPurchaseRequest[]>
    ) => {
        state.purchaseRequests = action.payload;
    },
    concatListPurchaseRequest: (
        state: PurchaseRequestState,
        action: PayloadAction<IPurchaseRequest[]>
    ) => {
        state.purchaseRequests = [
            ...state.purchaseRequests.concat(action.payload),
        ];
    },
    setPurchaseRequestToEdit: (
        state,
        action: PayloadAction<IPurchaseRequest | null>
    ) => {
        state.purchaseRequestToEdit = action.payload;
    },
    setURLToPurchaseRequestToEdit: (
        state,
        action: PayloadAction<string | null>
    ) => {
        // if (state.purchaseRequestToEdit)
        // state.purchaseRequestToEdit.url = action.payload;
    },
    addPurchaseRequest: (state, action: PayloadAction<IPurchaseRequest>) => {
        state.purchaseRequests.push(action.payload);
    },
    updatePurchaseRequest: (state, action: PayloadAction<IPurchaseRequest>) => {
        let itemIndex = state.purchaseRequests.findIndex(
            item => item.purchaseRequestId === action.payload.purchaseRequestId
        );
        if (itemIndex !== -1) state.purchaseRequests[itemIndex] = action.payload;
    },
    deletePurchaseRequest: (state, action: PayloadAction<number>) => {
        const newArray = state.purchaseRequests.filter(
            item => item.purchaseRequestId !== action.payload
        );
        state.purchaseRequests = newArray;
    },
    },
});

export const {
    setPurchaseRequestList,
    concatListPurchaseRequest,
    setPurchaseRequestToEdit,
    setURLToPurchaseRequestToEdit,
    addPurchaseRequest,
    updatePurchaseRequest,
    deletePurchaseRequest,
} = PurchaseRequestSlice.actions;

export default PurchaseRequestSlice.reducer;